import React from 'react';
import ProductCard from '../../../../components-legacy/ProductCard';
import useContext from '../../../../hooks/useContext';

import { ProductGrid as StyledProductGrid, ProductGridItem } from '../../../../styled/ProductGrid';

import { CategoryContext } from '../Providers/CategoryProvider';
import useViewSettings from '../Providers/ViewSettingsProvider';

const Products = () => {
  const { products } = useContext(CategoryContext);
  const { productView, showContextualImage } = useViewSettings();

  return (
    <StyledProductGrid productView={productView}>
      {products.map((product, index) => (
        <ProductGridItem productView={productView} key={product.id}>
          <ProductCard
            {...product}
            productView={productView}
            imageLoading={index < 7 ? 'eager' : 'lazy'}
            showContextualImage={showContextualImage}
          />
        </ProductGridItem>
      ))}
    </StyledProductGrid>
  );
};

export default Products;
